import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';
import { useQuery } from 'react-query';

import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';

export default function useGetadminblogdata({ userId, isDraft,searchText,
  filterValue, }) {
  return useQuery(['get-blog-data-admin', userId, isDraft,searchText, filterValue], async () => {
    const response = await makeApiRequest.get(
      createQueryParamsForGetReq(apiEndPoints.ADMIN_BLOG, {
        user_id: userId,
        is_deleted: 'False',
        is_draft: isDraft ? 'True' : 'False',
        search: searchText,
        created_date__year: filterValue,
      })
    );

    return response.data;
  });
}
